// import React from "react";
// import "../../css/ProfileDrawer.css";

// interface ProfileDrawerProps {
//   isOpen: boolean;
//   onClose: () => void;
//   user: any;
// }

// const ProfileDrawer: React.FC<ProfileDrawerProps> = ({
//   isOpen,
//   onClose,
//   user,
// }) => {

//   return (
//     <>
//       {isOpen && <div className="drawer-overlay" onClick={onClose} />}

//       <div className={`profile-drawer ${isOpen ? "open" : ""}`}>
//         <div className="drawer-header">
//           <div className="avatar-circle">
//             {user?.name?.charAt(0)?.toUpperCase() || "D"}
//           </div>
//           <div>
//             <h3>{user?.name}</h3>
//             <p>{user?.email}</p>
//           </div>
//           <button className="close-btn" onClick={onClose}>
//             ×
//           </button>
//         </div>

//         <div className="drawer-body">
//           <div className="info-row">
//             <label>Role</label>
//             <span>{user?.role}</span>
//           </div>

//           <div className="info-row">
//             <label>User ID</label>
//             <span>{user?._id}</span>
//           </div>

//           <div className="info-row">
//             <label>Joined</label>
//             <span>{user?.createdAt}</span>
//           </div>
//         </div>

//         <div className="drawer-footer">
//           {/* <button className="logout-btn">Logout</button> */}

//           <button
//             className="logout-btn"
//             onClick={() => {
//               onClose();
//               window.location.href = "/";
//             }}
//           >
//             Logout
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ProfileDrawer;

import React, { useState } from "react";
import "../../css/ProfileDrawer.css";
import api from "../../api/axiosConfig";

interface ProfileDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  user: any;
}

const ProfileDrawer: React.FC<ProfileDrawerProps> = ({
  isOpen,
  onClose,
  user,
}) => {
  if (!user) return null;

  const formatDate = (dateString?: string) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const [openSection, setOpenSection] = useState<string | null>("auth");
  const [signedDocMap, setSignedDocMap] = useState<Record<string, string>>({});

  const toggleSection = (section: string) => {
    setOpenSection(openSection === section ? null : section);
  };

  const raw = user?.user?.raw;
  const doctorProfile = raw?.app_metadata?.doctor_profile;
  const roleAssignment = user?.roleAssignments?.[0];

  // Extract email identity
  const emailIdentity = raw?.identities?.find((i: any) => i.profileData?.email);

  const smsIdentity = raw?.identities?.find(
    (i: any) => i.profileData?.phone_number,
  );

  const handlePreviewDocument = async (fullPath: string) => {
    try {
      const INTERNAL_TOKEN = "super-secret-password";

      if (!fullPath.includes("/")) return;

      const parts = fullPath.split("/");

      if (parts.length < 3) return;

      // doctors/documents
      const module = `${parts[0]}/${parts[1]}`;

      // DR-10023/mbbs/file.pdf
      const key = parts.slice(2).join("/");

      const res = await api.S3config.get("/view-url", {
        params: { module, key },
        headers: { "x-internal-token": INTERNAL_TOKEN },
      });

      if (res.data?.url) {
        window.open(res.data.url, "_blank");
      }
    } catch (err) {
      console.error("Preview failed:", err);
      alert("Failed to open document");
    }
  };

  return (
    <>
      {isOpen && <div className="drawer-overlay" onClick={onClose} />}

      <div className={`profile-drawer ${isOpen ? "open" : ""}`}>
        {/* HEADER */}
        <div className="drawer-header">
          <div className="avatar-circle">
            {doctorProfile?.firstName?.charAt(0)?.toUpperCase() || "D"}
          </div>

          <div>
            <h3>
              {doctorProfile?.firstName} {doctorProfile?.lastName}
            </h3>
            <p>
              {/* {emailIdentity?.profileData?.email} */}
              {raw?.app_metadata?.doctor_profile?.email || "Not provided"}
            </p>
          </div>

          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        {/* BODY */}
        {/* BODY */}
        <div className="drawer-body">
          {/* ================= AUTHENTICATION ================= */}
          <div className="section-header" onClick={() => toggleSection("auth")}>
            <span>Authentication</span>
            <span>{openSection === "auth" ? "▼" : "▶"}</span>
          </div>

          {openSection === "auth" && (
            <>
              <div className="info-row">
                <label>Auth0 ID</label>
                <span>{user?.auth0?.sub}</span>
              </div>

              <div className="info-row">
                <label>Email Verified</label>
                <span
                  className={
                    emailIdentity?.profileData?.email_verified
                      ? "badge verified"
                      : "badge not-verified"
                  }
                >
                  {emailIdentity?.profileData?.email_verified
                    ? "Verified"
                    : "Not Verified"}
                </span>
              </div>

              <div className="info-row">
                <label>Phone</label>
                <span>{smsIdentity?.profileData?.phone_number}</span>
              </div>

              <div className="info-row">
                <label>Phone Verified</label>
                <span
                  className={
                    smsIdentity?.profileData?.phone_verified
                      ? "badge verified"
                      : "badge not-verified"
                  }
                >
                  {smsIdentity?.profileData?.phone_verified
                    ? "Verified"
                    : "Not Verified"}
                </span>
              </div>

              <div className="info-row">
                <label>Last Login</label>
                <span>{formatDate(raw?.last_login)}</span>
              </div>

              <div className="info-row">
                <label>Last Password Reset</label>
                <span>{formatDate(raw?.last_password_reset)}</span>
              </div>
            </>
          )}

          {/* ================= ROLE ================= */}
          <div className="section-header" onClick={() => toggleSection("role")}>
            <span>Role</span>
            <span>{openSection === "role" ? "▼" : "▶"}</span>
          </div>

          {openSection === "role" && (
            <>
              <div className="info-row">
                <label>App Role</label>
                <span>{raw?.app_metadata?.role}</span>
              </div>

              <div className="info-row">
                <label>Status</label>
                {/* <span>{roleAssignment?.status}</span> */}
                <span style={{ fontWeight: 600 }}>
                  {raw?.app_metadata?.doctor_status || "Not Assigned"}
                </span>
              </div>
            </>
          )}

          {/* ================= DOCTOR PROFILE ================= */}
          <div
            className="section-header"
            onClick={() => toggleSection("profile")}
          >
            <span>Doctor Profile</span>
            <span>{openSection === "profile" ? "▼" : "▶"}</span>
          </div>

          {openSection === "profile" && (
            <>
              <div className="info-row">
                <label>Date of Birth</label>
                <span>{formatDate(doctorProfile?.dateOfBirth)}</span>
              </div>

              <div className="info-row">
                <label>NMC Registration</label>
                <span>{doctorProfile?.nmcRegistrationId}</span>
              </div>

              <div className="info-row">
                <label>Institution</label>
                <span>{doctorProfile?.practiceInstitutionName}</span>
              </div>

              <div className="info-row">
                <label>Graduate Degree</label>
                <span>{doctorProfile?.graduateDegree}</span>
              </div>

              <div className="info-row">
                <label>Institution Name</label>
                <span>{doctorProfile?.institutionName}</span>
              </div>

              <div className="info-row">
                <label>Practice Type</label>
                <span>{doctorProfile?.practiceType}</span>
              </div>

              <div className="info-row">
                <label>Practice City</label>
                <span>{doctorProfile?.practiceCity}</span>
              </div>

              {/* Documents */}
              <div className="info-row">Documents</div>

              {/* {doctorProfile?.documents?.map((doc: any, index: number) => (
                <div key={index} className="info-row">
                  <label>{doc.name}</label>
                  <span>{doc.mimetype}</span>
                </div>
              ))} */}

              {doctorProfile?.documents?.map((doc: any, index: number) => (
                <div key={index} className="info-row">
                  <label></label>

                  <span
                    style={{
                      cursor: "pointer",
                      color: "#e24c63",
                      fontWeight: 600,
                    }}
                    onClick={() => handlePreviewDocument(doc.path)}
                  >
                    View Document
                  </span>
                </div>
              ))}

              {/* <div className="info-row">
                <label>Additional Degrees</label>
                <span>
                  {doctorProfile?.additionalDegrees?.length
                    ? doctorProfile.additionalDegrees.join(", ")
                    : "None"}
                </span>
              </div> */}

              {/* Additional Degrees */}
              <div className="section-title">Additional Degrees</div>

              {doctorProfile?.additionalDegrees?.length ? (
                doctorProfile.additionalDegrees.map(
                  (deg: any, index: number) => (
                    <div
                      key={index}
                      className="info-row"
                      style={{
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <div style={{ fontWeight: 600 }}>
                        {deg.degreeName} ({deg.specialization})
                      </div>

                      <div style={{ fontSize: 13, color: "#666" }}>
                        {deg.institutionName}
                      </div>

                      {deg.certificateKey && (
                        <span
                          style={{
                            cursor: "pointer",
                            color: "#e24c63",
                            fontWeight: 600,
                            marginTop: 4,
                          }}
                          onClick={() =>
                            handlePreviewDocument(deg.certificateKey)
                          }
                        >
                          View Certificate
                        </span>
                      )}
                    </div>
                  ),
                )
              ) : (
                <div className="info-row">
                  <span>None</span>
                </div>
              )}
            </>
          )}

          {/* ================= FOOTER ================= */}
          <div className="drawer-footer">
            {/* <button className="logout-btn">Logout</button> */}

            <button
              className="logout-btn"
              onClick={() => {
                onClose();
                window.location.href = "/";
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileDrawer;
